export default {
    appname: '理财宝',
    login: '登录',
    go_wallet_to_do:"请在钱包客户端操作!",
    investment_is_too_small:"投资金额低于起投资金 !",
    no_balance:"余额不够,请先充值!",
    walletConnected:"连接钱包",
    openWallet: "请打开钱包客户端",
    app:{
        product:"产品",
        order:"订单",
        my:"我的",
    },
    productDetail:{
        arp:"年化",
        minimum:"起投资金",
        holdingPeriod:"投资周期",
        day:"天",
        basic_interest:"基本利息",
        team_interest:"团队利息",
        total_interest:"总共利息",
        expected_returns:"预期收益",
        principal:"本金",
        purchase_confirmation:"购买确认",
        condescribe1:"您确认购买",
        condescribe2:"产品",
        condescribe3:"锁仓",
        condescribe4:"天",
        condescribe5:"年化利息",
        condescribe6:"预期收益",
        condescribe7:"吗",

    },
    orderPage:{
        noOrders:"暂无任何订单",
        lockedPos:"锁仓计息",
        waitRed:"等待赎回",
        redComple:"赎回完成",
        unexpected:"意外中止",
        arp:"年化",
        end_time:"到期时间",
    },
    orderDetail:{
        purchTime:"购买时间",
        basic_interest:"基本利息",
        team_interest:"团队利息",
        total_profile:"总共盈利",
        total_interest:"总共利息",
        buy_amount:"投资金额",
        end_time:"到期时间",
        time:"时间",
    },
    my:{
        availableFunds:"可用资金",
        team_interest:"团队利息",
        withdrawals:"提款",
        charge:"充值",
        bill:"账单",
        team:"团队",
        announcement:"公告"

    },
    withdraw:{
        minimumWithdrawal:"最低提现",
        fees:"手续费用",
        every:"次",
        availableBalance:"可用余额",
        withdrawalAmount:"提现金额",
        time:"时间",
        date:"日期",
        amount:"金额",
        state:"状态",
        finish:"完成",
        pendding:"等待",
        fail:"失败",
        minwithdrawal:"提款金额错误,最低提款",

    },
    depositPage:{
        mincharge:"最低充值",
        chargeamount:"充值金额",
        rechargeDes:"平台充值地址是对公收款账户，请通过钱包充值，切勿通过交易所提款方式充值。",
        rechargeDes2:"请保护私钥安全，泄露私钥意味着您丢失平台资产的控制权。",
        charge:"充值",
        time:"时间",
        date:"日期",
        amount:"金额",
        state:"状态",
        rechargeOk:"充值成功，等待到账！",
        rechargeFail:"充值失败",
        someError:"出错啦",
        rechargeAmountError:"充值金额错误",
        minRecharge:"最低充值 10 USDT",
        balanceNo:"余额不足",
        finish:"完成",
        pendding:"等待",
        fail:"失败",

    },
    historyPage:{
        noHistory:"暂无任何账单",
        finish:"完成",
        pendding:"等待",
        fail:"失败",
        buy:"买入",
        sell:"卖出",
        recharge:"充值",
        withdrawal:"提款",
        award:"奖励",
        other:"其他",
        fee:"手续费",
    },
    teamPage:{
        desc:"朋友通过您邀请链接登入平台参与投资，双方都将获得10usdt邀请奖励，累计邀请指定数量的有效用户，你将获得指定的团队利息，团队利息及时生效。",
        invitValid:"邀请有效人数",
        team_interest:"团队利息",
        copy_url:"复制邀请链接",
        sleep:"休眠",
        activation:"激活",
        copyOk:"邀请链接已复制到剪贴板！",
        copyFail:"复制邀请链接失败，请手动复制：",

    },
    postPage:{
        email:"邮件联系我们",
        tg:"TG联系我们"
    },
    postDetail:{
        sincerely:"团队敬上",
        tg:"TG官方客服"
    },
    homePage:{
        arp:"年化",
        minimum:"起投资金",
        holdingPeriod:"投资周期",
        day:"天",
        heroKicker:"USDT · 链上生息",
        heroTitle:"私人财富，稳健增值",
        heroSub:"面向专业资金的去中心化存币生息。锁定周期，透明计息，随时查看持仓。",
        trust1:"钱包签名",
        trust2:"USDT 结算",
        trust3:"锁仓计息",
        products:"精选产品",
        investNow:"立即投资",
        empty:"暂无产品",
    },
    seo:{
        home:{
            title:"理财宝 CoinUp | USDT 链上生息与锁仓理财",
            description:"去中心化 USDT 存币生息平台。钱包签名、锁仓计息、链上结算。多种年化产品，最低 1000 USDT 起投。"
        },
        product:{
            title:"投资产品 | 理财宝 CoinUp",
            description:"查看 USDT 锁仓理财产品的年化、起投金额与投资周期，连接钱包即可申购。",
            dynamicTitle:"{name} {arp}% 年化 | 理财宝",
            dynamicDesc:"{name}：年化 {arp}%，起投 {min} USDT，锁仓 {days} 天。在 CoinUp 理财宝链上申购。"
        },
        post:{
            title:"平台公告 | 理财宝 CoinUp",
            description:"理财宝官方公告与产品更新，了解锁仓规则、结算与客服联系方式。"
        },
        postDetail:{
            title:"公告详情 | 理财宝",
            description:"理财宝平台公告详情。"
        },
        my:{ title:"我的账户 | 理财宝", description:"连接钱包查看可用资金与团队利息。" },
        team:{ title:"邀请团队 | 理财宝", description:"邀请好友投资，双方获得奖励并解锁团队利息。" },
        withdraw:{ title:"提款 | 理财宝", description:"将可用 USDT 余额提现到钱包。" },
        deposit:{ title:"充值 | 理财宝", description:"通过钱包向平台充值 USDT。" },
        order:{ title:"我的订单 | 理财宝", description:"查看锁仓订单与赎回状态。" },
        orderDetail:{ title:"订单详情 | 理财宝", description:"查看单笔投资的计息与到期信息。" },
        history:{ title:"账单 | 理财宝", description:"充值、提现与投资流水。" }
    },
    faq:{
        title:"常见问题",
        q1:"理财宝是什么？",
        a1:"理财宝（CoinUp）是面向 USDT 的链上锁仓生息平台。您连接钱包并签名后，可按产品周期锁定本金，按年化计息。",
        q2:"如何开始投资？",
        a2:"打开 coinupusa.com，连接钱包并登录，选择产品输入本金，确认后在钱包内签名即可完成申购。余额不足时请先充值 USDT。",
        q3:"收益如何计算？",
        a3:"收益按产品年化与锁仓天数估算：预期收益 ≈ 本金 ×（基本利息+团队利息）÷ 365 × 锁仓天数。团队利息随有效邀请人数变化。",
        q4:"支持哪些网络？",
        a4:"支持通过钱包在 Ethereum 与 BNB Chain 上使用 USDT 充值与结算，请勿从交易所直接提币到平台地址。"
    },
    button: {
        buy: '购买',
        confirmation: '确认',
        cancel: '取消',
        charge: '充值',
        redemption: '赎回',
        withdrawal:"提款",
    }
};